import React from 'react';
import './style.css';

export default function Index() {
  return (
    <div className="container-error">
        <img src="image-404.png" alt="" className="error-404" />
    </div>
  )
}
